// src/app/guards/first-time.guard.ts
import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { WelcomeService } from '../../core/services/welcome.service';

@Injectable({ providedIn: 'root' })
export class FirstTimeGuard implements CanActivate {
  constructor(
    private ws: WelcomeService,
    private router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean  | UrlTree {
    if (!this.ws.hasSeen()) {
      // first visit → send them to welcome
      return this.router.createUrlTree(['/welcome']);
      //return false;
    }
    // otherwise allow navigation
    return true;
  }
}
